var _defs, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeydarAliyevCenterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_57",
    "data-name": "Group 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.204,
    height: 44.343,
    viewBox: "0 0 49.204 44.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 49.204,
    height: 44.343,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M5.1,44.148V42.019H3.392v2.128H2.773V39.663h.619v1.842H5.1V39.663h.631v4.485Z",
    transform: "translate(-0.537 -7.687)",
    fill: "#818386"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M8.1,44.148V39.663h2.441l-.085.514H8.739v1.367h1.439v.527H8.739v1.537h1.875v.54Z",
    transform: "translate(-1.57 -7.687)",
    fill: "#818386"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M13.69,42.365v1.783H13.04v-1.8l-1.42-2.689h.768l.743,1.53a5.783,5.783,0,0,1,.248.579c.077-.182.162-.371.26-.572l.755-1.537h.729Z",
    transform: "translate(-2.252 -7.687)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M19.441,43.542a1.718,1.718,0,0,1-1.51.605h-1.12V39.663h1.042a1.811,1.811,0,0,1,1.679.742,2.555,2.555,0,0,1,.4,1.5,2.529,2.529,0,0,1-.489,1.634m-.54-2.981a1.035,1.035,0,0,0-.944-.4H17.45v3.469h.494a1.052,1.052,0,0,0,1.048-.5,2.443,2.443,0,0,0,.241-1.146,2.233,2.233,0,0,0-.332-1.425",
    transform: "translate(-3.258 -7.687)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M24.586,41.721v-.144c0-.839-.4-1.523-1.289-1.523a1.675,1.675,0,0,0-1.1.423l-.248-.391a1.98,1.98,0,0,1,1.4-.521c1.321,0,1.992.885,1.992,2.278a2.6,2.6,0,0,1-.605,1.868,1.62,1.62,0,0,1-1.211.489,1.556,1.556,0,0,1-1.165-.436,2.486,2.486,0,0,1-.527-1.927v-.117Zm-1.751,1.692a.872.872,0,0,0,.7.313c.7,0,1.048-.586,1.048-1.511H22.542a1.837,1.837,0,0,0,.293,1.2",
    transform: "translate(-4.231 -7.668)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M29.771,44.148c-.13-.254-.189-.358-.371-.664a6.055,6.055,0,0,0-.775-1.12.5.5,0,0,0-.4-.2v1.985H27.6V39.663h1.257a1.452,1.452,0,0,1,1.061.326,1.231,1.231,0,0,1,.4.924,1.137,1.137,0,0,1-1.146,1.23h-.052a1.963,1.963,0,0,1,.39.417c.091.124.228.319.377.553l.651,1.035Zm-.534-3.886a1.5,1.5,0,0,0-.547-.085h-.469V41.74h.436a1.04,1.04,0,0,0,.775-.215.825.825,0,0,0,.222-.605.683.683,0,0,0-.417-.657",
    transform: "translate(-5.348 -7.687)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M36.881,41.721v-.144c0-.839-.4-1.523-1.289-1.523a1.675,1.675,0,0,0-1.1.423l-.248-.391a1.98,1.98,0,0,1,1.4-.521c1.321,0,1.991.885,1.991,2.278a2.6,2.6,0,0,1-.605,1.868,1.617,1.617,0,0,1-1.21.489,1.556,1.556,0,0,1-1.165-.436,2.486,2.486,0,0,1-.527-1.927v-.117ZM35.13,43.413a.872.872,0,0,0,.7.313c.7,0,1.048-.586,1.048-1.511H34.837a1.837,1.837,0,0,0,.293,1.2",
    transform: "translate(-6.614 -7.668)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M42.132,44.148H39.893V39.663h.638v3.964h1.705Z",
    transform: "translate(-7.731 -7.687)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M44.111,39.106a.453.453,0,1,1,.436-.456.449.449,0,0,1-.436.456m-.293.273h.638v4.485h-.638Z",
    transform: "translate(-8.468 -7.403)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M47.556,42.365v1.783h-.651v-1.8l-1.42-2.689h.768L47,41.193a5.6,5.6,0,0,1,.247.579c.078-.182.163-.371.261-.572l.755-1.537h.729Z",
    transform: "translate(-8.815 -7.687)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M50.677,44.148V39.663h2.441l-.085.514H51.315v1.367h1.439v.527H51.315v1.537H53.19v.54Z",
    transform: "translate(-9.821 -7.687)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M56.467,44.161h-.612l-1.5-4.5h.69l.859,2.7c.052.156.123.4.169.593.032.144.058.248.071.339h.039c.072-.293.163-.6.273-.938l.879-2.694h.651Z",
    transform: "translate(-10.534 -7.687)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M17.911,53.836l-.235-3.053c-.019-.24-.026-.6-.032-.729h-.013c-.027.131-.091.43-.163.671l-.892,3.111h-.54l-.821-2.968c-.1-.345-.169-.676-.2-.82H15c-.006.156-.026.586-.045.82l-.228,2.968h-.612l.4-4.485H15.4l.755,2.753a7.043,7.043,0,0,1,.163.736h.013c.019-.111.072-.4.156-.7l.781-2.786h.885l.384,4.485Z",
    transform: "translate(-2.736 -9.564)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M23.529,51.408v-.144c0-.839-.4-1.523-1.289-1.523a1.676,1.676,0,0,0-1.1.423l-.248-.391a1.981,1.981,0,0,1,1.4-.521c1.321,0,1.992.885,1.992,2.278a2.6,2.6,0,0,1-.605,1.868,1.62,1.62,0,0,1-1.211.489,1.556,1.556,0,0,1-1.165-.436,2.486,2.486,0,0,1-.527-1.927v-.117ZM21.778,53.1a.872.872,0,0,0,.7.313c.7,0,1.048-.586,1.048-1.511H21.485a1.837,1.837,0,0,0,.293,1.2",
    transform: "translate(-4.026 -9.545)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M28.713,53.835c-.13-.254-.189-.358-.371-.664a6.055,6.055,0,0,0-.775-1.12.5.5,0,0,0-.4-.2v1.985h-.626V49.35H27.8a1.452,1.452,0,0,1,1.061.326,1.231,1.231,0,0,1,.4.924,1.137,1.137,0,0,1-1.146,1.23h-.052a1.942,1.942,0,0,1,.39.417c.091.124.228.319.377.553l.651,1.035Zm-.534-3.886a1.491,1.491,0,0,0-.547-.085h-.468v1.562H27.6a1.04,1.04,0,0,0,.775-.215.824.824,0,0,0,.222-.6.683.683,0,0,0-.417-.658",
    transform: "translate(-5.143 -9.564)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M31.31,49.351h.638v4.485H31.31Zm2.265,4.485-1.6-2.4,1.569-2.09h.788L32.69,51.434l1.7,2.4Z",
    transform: "translate(-6.068 -9.564)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M38.432,51.408v-.144c0-.839-.4-1.523-1.289-1.523a1.675,1.675,0,0,0-1.1.423l-.248-.391a1.981,1.981,0,0,1,1.4-.521c1.321,0,1.991.885,1.991,2.278a2.6,2.6,0,0,1-.605,1.868,1.617,1.617,0,0,1-1.21.489,1.556,1.556,0,0,1-1.165-.436,2.486,2.486,0,0,1-.527-1.927v-.117ZM36.681,53.1a.872.872,0,0,0,.7.313c.7,0,1.048-.586,1.048-1.511H36.388a1.837,1.837,0,0,0,.293,1.2",
    transform: "translate(-6.914 -9.545)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M43.593,53.836H40.918v-.481l1.809-3.04a4.281,4.281,0,0,1,.319-.462c-.131.013-.293.019-.514.019H41l.15-.521h2.577v.5l-1.79,3.039c-.1.169-.2.3-.28.43.137-.006.286-.006.449-.006h1.647Z",
    transform: "translate(-7.93 -9.564)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M45.984,48.794a.453.453,0,1,1,.436-.456.449.449,0,0,1-.436.456m-.293.273h.638v4.485h-.638Z",
    transform: "translate(-8.831 -9.281)",
    fill: "#818386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M3.165,27.68c-2.652-2.43-4.1-5.52-2.493-9A6.779,6.779,0,0,1,5.339,14.8c2.637-.551,7.378-.252,10.354-.48,9.72-.743,11.888-4.646,18.6-10.765,2.576-2.348,8.09-5.32,11.419-2.224,2.48,2.306,3.073,8.851,3.32,12.165.364,4.891.689,10.436-5.257,10.564l-6.564-.067-6.565-.062s12.93-.121,13.129-.13c5.668-.24,5.153-5.59,4.681-10.254-.3-2.989-1.084-9.491-3.4-11.492-2.2-1.9-6.189-.1-8.163,1.394C29.385,9.115,26.049,14.383,15.73,14.895c-2.943.146-7.726-.262-10.336.224A6.508,6.508,0,0,0,.848,18.762c-1.657,3.4-.248,6.48,2.317,8.918",
    transform: "translate(0 0)",
    fill: "#818386",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M2.373,18.06c2.122-1.354,4.253.414,5.9,1.81,3.872,3.286,8.272,8.771,13.926,8.073,5.248-.647,7.944-7.118,10.072-11.452C34.026,12.908,39.03,2.514,43.851,3.437c4.229.809,3.943,11.808,3.864,15.112,0-3.032-.044-14.049-3.943-14.663-5.5-.864-9.578,12.232-11.708,16.24-2.088,3.929-5.354,8.51-10.365,8.563-5.751.06-9.658-5.206-13.543-8.69-1.592-1.429-3.647-3.23-5.784-1.94",
    transform: "translate(-0.46 -0.655)",
    fill: "#818386",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeydarAliyevCenterLogo);
export default __webpack_public_path__ + "static/media/heydar_aliyev_center_logo.3fab47b0a13571e5e46b7c0c61cede6c.svg";
export { ForwardRef as ReactComponent };